<template>
  <el-card class="box-card" style="height: 99.5%; padding: 20px">
    <div style="top: 10px; position: absolute; right: 10px">
      <el-link type="primary" @click="logout">退出登录</el-link>
    </div>
    <div
      slot="header"
      class="clearfix"
      style="
        font-weight: 900;
        font-size: 25px;
        text-align: center;
        margin-top: 160px;
      "
    >
      <span>{{ currentYear }}年玉树州中考成绩查询</span>
    </div>

    <el-table :data="studentData" border style="width: 100%">
      <el-table-column prop="name" label="姓名"> </el-table-column>
      <el-table-column prop="sex" label="性别"> </el-table-column>
      <el-table-column prop="idCard" label="身份证号"> </el-table-column>
      <el-table-column prop="testNum" label="准考证号"> </el-table-column>
      <el-table-column prop="sick" label="体检结果(根据各市县上报结果读取)">
      </el-table-column>
      <el-table-column prop="zongfen" label="总分"> </el-table-column>
      <el-table-column prop="rank" label="州排名(仅供参考,以一分一段表为准)">
      </el-table-column>
      <el-table-column prop="sameCount" label="同分人数"> </el-table-column>
      <el-table-column prop="luqujieguo" label="录取结果"> </el-table-column>
      <el-table-column label="操作" width="260">
        <template slot-scope="scope">
          <!-- 树表参数开始 -->
          <el-link type="danger" @click="changePwd(scope.row)"
            >修改密码</el-link
          >

          <el-link type="primary" @click="zhiyuan(scope.row)" v-if="zhiyuanFlag">我的志愿</el-link>
          <!-- <el-link
            type="primary"
            @click="gaozhongzhiyuan(scope.row)"
            v-if="zhiyuanFlag"
            >高中志愿</el-link
          >
          <el-link
            type="primary"
            @click="zhongzhizhiyuan(scope.row)"
            v-if="zhiyuanFlag"
            >中职志愿</el-link
          > -->
        </template>
      </el-table-column>
    </el-table>

    <el-table :data="scoreData" border style="width: 100%">
      <el-table-column prop="yuwen" label="语文"> </el-table-column>
      <el-table-column prop="shuxue" label="数学"> </el-table-column>
      <el-table-column prop="wuli" label="物理"> </el-table-column>
      <el-table-column prop="huaxue" label="化学"> </el-table-column>
      <el-table-column prop="daodefazhi" label="道德与法治"> </el-table-column>
      <el-table-column prop="lishi" label="历史"> </el-table-column>
      <el-table-column prop="yingyu" label="英语"> </el-table-column>
      <el-table-column prop="huaxueshiyan" label="化学实验"> </el-table-column>
      <el-table-column prop="wulishiyan" label="物理实验"> </el-table-column>
      <el-table-column prop="shengwushiyan" label="生物实验"> </el-table-column>
      <el-table-column prop="tiyu" label="体育"> </el-table-column>
      <el-table-column prop="shengwu" :label="shengwuName"> </el-table-column>
      <el-table-column prop="dili" label="地理"> </el-table-column>
      <el-table-column
        prop="zangyuwen"
        label="藏语文"
        v-if="languageType === '1'"
      >
      </el-table-column>
    </el-table>
    <el-dialog title="修改密码" :visible.sync="showChangePwd">
      <el-form
        :model="passwordForm"
        :rules="rules"
        ref="passwordForm"
        label-width="100px"
      >
        <el-form-item label="原密码:" prop="oldPwd">
          <el-input
            v-model="passwordForm.oldPwd"
            size="small"
            type="password"
          ></el-input>
        </el-form-item>

        <el-form-item label="新密码" prop="newPwd">
          <el-input
            v-model="passwordForm.newPwd"
            size="small"
            type="password"
          ></el-input>
        </el-form-item>

        <el-form-item label="确认新密码" prop="reNewPwd">
          <el-input
            v-model="passwordForm.reNewPwd"
            size="small"
            type="password"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            @click="savePwd('passwordForm')"
            size="small"
            type="primary"
            style="float: right"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-drawer
      title="高中志愿"
      :visible.sync="showGaoZhongZhiyuan"
      size="50%"
      @open="redirectToZhiyuan"
    >
      <el-form
        :model="zhiyuanForm"
        ref="gaozhongForm"
        label-width="100px"
        id="gzPrint"
      >
        <el-collapse v-model="activeName">
          <el-collapse-item
            title="第一批次"
            name="1"
            v-if="gaozhongBatchCount >= 1"
          >
            <el-form-item
              label="第一志愿"
              prop="z11"
              v-if="gaozhongSchoolCount >= 1"
            >
              <el-select
                v-model="zhiyuanForm.z11"
                clearable
                placeholder="请选择第一志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g1"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第二志愿"
              prop="z12"
              v-if="gaozhongSchoolCount >= 2"
            >
              <el-select
                v-model="zhiyuanForm.z12"
                clearable
                placeholder="请选择第二志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g1"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第三志愿"
              prop="z13"
              v-if="gaozhongSchoolCount >= 3"
            >
              <el-select
                v-model="zhiyuanForm.z13"
                clearable
                placeholder="请选择第三志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g1"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第四志愿"
              prop="z14"
              v-if="gaozhongSchoolCount >= 4"
            >
              <el-select
                v-model="zhiyuanForm.z14"
                clearable
                placeholder="请选择第四志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g1"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第五志愿"
              prop="z15"
              v-if="gaozhongSchoolCount >= 5"
            >
              <el-select
                v-model="zhiyuanForm.z15"
                clearable
                placeholder="请选择第五志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g5"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item
            title="第二批次"
            name="2"
            v-if="gaozhongBatchCount >= 2"
          >
            <el-form-item
              label="第一志愿"
              prop="z21"
              v-if="gaozhongSchoolCount >= 1"
            >
              <el-select
                v-model="zhiyuanForm.z21"
                clearable
                placeholder="请选择第一志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g2"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第二志愿"
              prop="z22"
              v-if="gaozhongSchoolCount >= 2"
            >
              <el-select
                v-model="zhiyuanForm.z22"
                clearable
                placeholder="请选择第二志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g2"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第三志愿"
              prop="z23"
              v-if="gaozhongSchoolCount >= 3"
            >
              <el-select
                v-model="zhiyuanForm.z23"
                clearable
                placeholder="请选择第三志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g2"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第四志愿"
              prop="z24"
              v-if="gaozhongSchoolCount >= 4"
            >
              <el-select
                v-model="zhiyuanForm.z24"
                clearable
                placeholder="请选择第四志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g2"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第五志愿"
              prop="z25"
              v-if="gaozhongSchoolCount >= 5"
            >
              <el-select
                v-model="zhiyuanForm.z25"
                clearable
                placeholder="请选择第五志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g2"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item
            title="第三批次"
            name="3"
            v-if="gaozhongBatchCount >= 3"
          >
            <el-form-item
              label="第一志愿"
              prop="z31"
              v-if="gaozhongSchoolCount >= 1"
            >
              <el-select
                v-model="zhiyuanForm.z31"
                clearable
                placeholder="请选择第一志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g3"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第二志愿"
              prop="z32"
              v-if="gaozhongSchoolCount >= 2"
            >
              <el-select
                v-model="zhiyuanForm.z32"
                clearable
                placeholder="请选择第二志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g3"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第三志愿"
              prop="z33"
              v-if="gaozhongSchoolCount >= 3"
            >
              <el-select
                v-model="zhiyuanForm.z33"
                clearable
                placeholder="请选择第三志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g3"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第四志愿"
              prop="z34"
              v-if="gaozhongSchoolCount >= 4"
            >
              <el-select
                v-model="zhiyuanForm.z34"
                clearable
                placeholder="请选择第四志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g3"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第五志愿"
              prop="z35"
              v-if="gaozhongSchoolCount >= 5"
            >
              <el-select
                v-model="zhiyuanForm.z35"
                clearable
                placeholder="请选择第五志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g3"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item
            title="第四批次"
            name="4"
            v-if="gaozhongBatchCount >= 4"
          >
            <el-form-item
              label="第一志愿"
              prop="z41"
              v-if="gaozhongSchoolCount >= 1"
            >
              <el-select
                v-model="zhiyuanForm.z41"
                clearable
                placeholder="请选择第一志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g4"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第二志愿"
              prop="z42"
              v-if="gaozhongSchoolCount >= 2"
            >
              <el-select
                v-model="zhiyuanForm.z42"
                clearable
                placeholder="请选择第二志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g4"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第三志愿"
              prop="z43"
              v-if="gaozhongSchoolCount >= 3"
            >
              <el-select
                v-model="zhiyuanForm.z43"
                clearable
                placeholder="请选择第三志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g4"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第四志愿"
              prop="z44"
              v-if="gaozhongSchoolCount >= 4"
            >
              <el-select
                v-model="zhiyuanForm.z44"
                clearable
                placeholder="请选择第四志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g4"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第五志愿"
              prop="z45"
              v-if="gaozhongSchoolCount >= 5"
            >
              <el-select
                v-model="zhiyuanForm.z45"
                clearable
                placeholder="请选择第五志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g4"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item
            title="第五批次"
            name="5"
            v-if="gaozhongBatchCount >= 5"
          >
            <el-form-item
              label="第一志愿"
              prop="z51"
              v-if="gaozhongSchoolCount >= 1"
            >
              <el-select
                v-model="zhiyuanForm.z51"
                clearable
                placeholder="请选择第一志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g5"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第二志愿"
              prop="z52"
              v-if="gaozhongSchoolCount >= 2"
            >
              <el-select
                v-model="zhiyuanForm.z52"
                clearable
                placeholder="请选择第二志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g5"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第三志愿"
              prop="z53"
              v-if="gaozhongSchoolCount >= 3"
            >
              <el-select
                v-model="zhiyuanForm.z53"
                clearable
                placeholder="请选择第三志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g5"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第四志愿"
              prop="z54"
              v-if="gaozhongSchoolCount >= 4"
            >
              <el-select
                v-model="zhiyuanForm.z54"
                clearable
                placeholder="请选择第四志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g5"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第五志愿"
              prop="z55"
              v-if="gaozhongSchoolCount >= 5"
            >
              <el-select
                v-model="zhiyuanForm.z55"
                clearable
                placeholder="请选择第五志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in g5"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>
        </el-collapse>
        <el-form-item
          style="margin-top: 10px; float: right; margin-right: 20px"
          class="noprint"
        >
          <el-button
            @click="redirectToZhiyuan"
            size="small"
            type="primary"
            >进入志愿填报</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>

    <el-drawer
      title="中职志愿"
      :visible.sync="showZhongZhiZhiyuan"
      size="50%"
      @open="redirectToZhiyuan"
    >
      <el-form
        :model="zhiyuanForm"
        ref="zhongzhiForm"
        label-width="100px"
        id="zzPrint"
      >
        <el-collapse v-model="activeName">
          <el-collapse-item
            title="第一批次"
            name="1"
            v-if="zhongzhiBatchCount >= 1"
          >
            <el-form-item
              label="第一志愿"
              prop="z11"
              v-if="zhongzhiSchoolCount >= 1"
            >
              <el-select
                v-model="zhiyuanForm.z11"
                clearable
                placeholder="请选择第一志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z1"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第二志愿"
              prop="z12"
              v-if="zhongzhiSchoolCount >= 2"
            >
              <el-select
                v-model="zhiyuanForm.z12"
                clearable
                placeholder="请选择第二志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z1"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第三志愿"
              prop="z13"
              v-if="zhongzhiSchoolCount >= 3"
            >
              <el-select
                v-model="zhiyuanForm.z13"
                clearable
                placeholder="请选择第三志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z1"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第四志愿"
              prop="z14"
              v-if="zhongzhiSchoolCount >= 4"
            >
              <el-select
                v-model="zhiyuanForm.z14"
                clearable
                placeholder="请选择第四志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z1"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第五志愿"
              prop="z15"
              v-if="zhongzhiSchoolCount >= 5"
            >
              <el-select
                v-model="zhiyuanForm.z15"
                clearable
                placeholder="请选择第五志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z1"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item
            title="第二批次"
            name="2"
            v-if="zhongzhiBatchCount >= 2"
          >
            <el-form-item
              label="第一志愿"
              prop="z21"
              v-if="zhongzhiSchoolCount >= 1"
            >
              <el-select
                v-model="zhiyuanForm.z21"
                clearable
                placeholder="请选择第一志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z2"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第二志愿"
              prop="z22"
              v-if="zhongzhiSchoolCount >= 2"
            >
              <el-select
                v-model="zhiyuanForm.z22"
                clearable
                placeholder="请选择第二志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z2"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第三志愿"
              prop="z23"
              v-if="zhongzhiSchoolCount >= 3"
            >
              <el-select
                v-model="zhiyuanForm.z23"
                clearable
                placeholder="请选择第三志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z2"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第四志愿"
              prop="z24"
              v-if="zhongzhiSchoolCount >= 4"
            >
              <el-select
                v-model="zhiyuanForm.z24"
                clearable
                placeholder="请选择第四志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z2"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第五志愿"
              prop="z25"
              v-if="zhongzhiSchoolCount >= 5"
            >
              <el-select
                v-model="zhiyuanForm.z25"
                clearable
                placeholder="请选择第五志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z2"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item
            title="第三批次"
            name="3"
            v-if="zhongzhiBatchCount >= 3"
          >
            <el-form-item
              label="第一志愿"
              prop="z31"
              v-if="zhongzhiSchoolCount >= 1"
            >
              <el-select
                v-model="zhiyuanForm.z31"
                clearable
                placeholder="请选择第一志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z3"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第二志愿"
              prop="z32"
              v-if="zhongzhiSchoolCount >= 2"
            >
              <el-select
                v-model="zhiyuanForm.z32"
                clearable
                placeholder="请选择第二志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z3"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第三志愿"
              prop="z33"
              v-if="zhongzhiSchoolCount >= 3"
            >
              <el-select
                v-model="zhiyuanForm.z33"
                clearable
                placeholder="请选择第三志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z3"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第四志愿"
              prop="z34"
              v-if="zhongzhiSchoolCount >= 4"
            >
              <el-select
                v-model="zhiyuanForm.z34"
                clearable
                placeholder="请选择第四志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z3"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第五志愿"
              prop="z35"
              v-if="zhongzhiSchoolCount >= 5"
            >
              <el-select
                v-model="zhiyuanForm.z35"
                clearable
                placeholder="请选择第五志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z3"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item
            title="第四批次"
            name="4"
            v-if="zhongzhiBatchCount >= 4"
          >
            <el-form-item
              label="第一志愿"
              prop="z41"
              v-if="zhongzhiSchoolCount >= 1"
            >
              <el-select
                v-model="zhiyuanForm.z41"
                clearable
                placeholder="请选择第一志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z4"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第二志愿"
              prop="z42"
              v-if="zhongzhiSchoolCount >= 2"
            >
              <el-select
                v-model="zhiyuanForm.z42"
                clearable
                placeholder="请选择第二志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z4"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第三志愿"
              prop="z43"
              v-if="zhongzhiSchoolCount >= 3"
            >
              <el-select
                v-model="zhiyuanForm.z43"
                clearable
                placeholder="请选择第三志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z4"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第四志愿"
              prop="z44"
              v-if="zhongzhiSchoolCount >= 4"
            >
              <el-select
                v-model="zhiyuanForm.z44"
                clearable
                placeholder="请选择第四志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z4"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第五志愿"
              prop="z45"
              v-if="zhongzhiSchoolCount >= 5"
            >
              <el-select
                v-model="zhiyuanForm.z45"
                clearable
                placeholder="请选择第五志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z4"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item
            title="第五批次"
            name="5"
            v-if="zhongzhiBatchCount >= 5"
          >
            <el-form-item
              label="第一志愿"
              prop="z51"
              v-if="zhongzhiSchoolCount >= 1"
            >
              <el-select
                v-model="zhiyuanForm.z51"
                clearable
                placeholder="请选择第一志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z5"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第二志愿"
              prop="z52"
              v-if="zhongzhiSchoolCount >= 2"
            >
              <el-select
                v-model="zhiyuanForm.z52"
                clearable
                placeholder="请选择第二志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z5"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第三志愿"
              prop="z53"
              v-if="zhongzhiSchoolCount >= 3"
            >
              <el-select
                v-model="zhiyuanForm.z53"
                clearable
                placeholder="请选择第三志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z5"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第四志愿"
              prop="z54"
              v-if="zhongzhiSchoolCount >= 4"
            >
              <el-select
                v-model="zhiyuanForm.z54"
                clearable
                placeholder="请选择第四志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z5"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第五志愿"
              prop="z55"
              v-if="zhongzhiSchoolCount >= 5"
            >
              <el-select
                v-model="zhiyuanForm.z55"
                clearable
                placeholder="请选择第五志愿"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in z5"
                  :key="item.id"
                  :label="item.school"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>
        </el-collapse>
        <el-form-item
          style="margin-top: 10px; float: right; margin-right: 20px"
          class="noprint"
        >
          <el-button
            @click="redirectToZhiyuan"
            size="small"
            type="primary"
            >进入志愿填报</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </el-card>
</template>

<script>
import {
  changePwd,
  getStudentInfo
} from '@/common/apis/main.js'
export default {
  inject: ['reload'],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.passwordForm.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      pageData: {
        start: '0',
        length: '10'
      },
      mainInfo: {
        logoPic: '',
        userImg: ''
      },
      passwordForm: {
        oldPwd: '',
        newPwd: '',
        reNewPwd: ''
      },

      rules: {
        oldPwd: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        reNewPwd: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          {
            min: 6,
            max: 20,
            message: '长度在 6 到 20 个字符',
            trigger: 'blur'
          },
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      width: '200px',
      isCollapse: false,
      menuList: [],
      judgeEnv: '',
      showChangePwd: false,
      showGaoZhongZhiyuan: false,
      showZhongZhiZhiyuan: false,
      editableTabsValue: '1',
      editableTabs: [],
      mainPagePath: '',
      top: '',
      left: '',
      contextMenuVisible: false,
      currentContextTabId: '',
      studentName: this.$store.getters.getUser.name,
      currentYear: '',
      scoreData: [],
      studentData: [],
      languageType: '',
      zhongzhiBatchCount: 0,
      zhongzhiSchoolCount: 0,
      gaozhongBatchCount: 0,
      gaozhongSchoolCount: 0,
      zhiyuanForm: {
        z11: '',
        z12: '',
        z13: '',
        z14: '',
        z15: '',
        z21: '',
        z22: '',
        z23: '',
        z24: '',
        z25: '',
        z31: '',
        z32: '',
        z33: '',
        z34: '',
        z35: '',
        z41: '',
        z42: '',
        z43: '',
        z44: '',
        z45: '',
        z51: '',
        z52: '',
        z53: '',
        z54: '',
        z55: ''
      },
      //高中1-5批次学校集合
      g1: [],
      g2: [],
      g3: [],
      g4: [],
      g5: [],
      //中职1-5批次学校集合
      z1: [],
      z2: [],
      z3: [],
      z4: [],
      z5: [],
      activeName: ['1', '2', '3', '4', '5'],
      action: '',
      zzFlag: '',
      gzFlag: '',
      disabledSub: false,
      printObjzz: {
        id: 'zzPrint',
        popTitle: '考生中职志愿确认单'
      },
      printObjgz: {
        id: 'gzPrint',
        popTitle: '考生高中志愿确认单'
      },
      shengwuName: '生物',
      zhiyuanFlag: false,
      studentInfo: {}
    }
  },

  created() {
    const nowTime = new Date()
    let year = nowTime.getFullYear() + ''
    this.currentYear = year
    this.getStudentInfo()
  },
  methods: {
    getStudentInfo() {
      getStudentInfo().then((res) => {
        if (res.data.code === '0000') {
          this.scoreData = res.data.data.score
          this.studentData = res.data.data.info
          if (this.studentData[0].shengwuflag === '1') {
            this.shengwuName = '生物(含实验)'
          }
          this.zhiyuanFlag = res.data.data.zhiyuanFlag
          this.languageType = res.data.data.languageType
          this.zhongzhiBatchCount = parseInt(res.data.data.zhongzhiBatchCount)
          this.zhongzhiSchoolCount = parseInt(res.data.data.zhongzhiSchoolCount)
          this.gaozhongBatchCount = parseInt(res.data.data.gaozhongBatchCount)
          this.gaozhongSchoolCount = parseInt(res.data.data.gaozhongSchoolCount)
          this.zzFlag = res.data.data.zzFlag
          this.gzFlag = res.data.data.gzFlag
          let zhiyuanObj = res.data.data.zhiyuan
          this.g1 = zhiyuanObj.g1
          this.g2 = zhiyuanObj.g2
          this.g3 = zhiyuanObj.g3
          this.g4 = zhiyuanObj.g4
          this.g5 = zhiyuanObj.g5

          this.z1 = zhiyuanObj.z1
          this.z2 = zhiyuanObj.z2
          this.z3 = zhiyuanObj.z3
          this.z4 = zhiyuanObj.z4
          this.z5 = zhiyuanObj.z5
          this.studentInfo = res.data.data.studentInfo
        } else if (res.data.code === '0001') {
          this.$message.error(res.data.message)
          return false
        }
      })
    },
    logout() {
      this.$router.push('/logout')
    },
    changePwd() {
      this.showChangePwd = true
    },
    gaozhongzhiyuan() {
      this.redirectToZhiyuan()
    },
    zhongzhizhiyuan() {
      this.redirectToZhiyuan()
    },
    saveAdmit() {
      this.redirectToZhiyuan()
    },
    savePwd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          changePwd(this.passwordForm).then((res) => {
            if (res.data.code === '0000') {
              this.$message.success(res.data.message)
              //重新登录
              this.$router.push('/logout')
            } else if (res.data.code === '0001') {
              this.$message.error(res.data.message)
              return false
            }
          })
        }
      })
    },
    logout() {
      this.$router.push('/logout')
    },
    zhiyuan() {
      this.redirectToZhiyuan()
    },
    redirectToZhiyuan() {
      this.showZhongZhiZhiyuan = false
      this.showGaoZhongZhiyuan = false
      this.$router.push('/zhiyuan')
    }
  }
}
</script>

<style scoped>
.el-main {
  padding: 5px 10px;
}
.el-container,
.main-container {
  height: 100%;
}

.el-icon-s-fold {
  color: gray;
}

.el-icon-s-unfold {
  color: gray;
}

@media print {
  @page {
    size: auto;
    margin-left: 20mm;
    margin-top: 30mm;
    margin-bottom: 0mm;
  }
  .noprint {
    display: none;
  }
}
</style>
